import Spinner from "../../shared/Spinner/Spinner";
import { Button, Modal as BootstrapModal } from "react-bootstrap";

export default function InfoModal
  ({ show, onHide, loading, title, body, primaryText, primaryOnClick, primaryDisabled }) {

  return (
    <BootstrapModal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal"
    >

      <BootstrapModal.Header>
        <BootstrapModal.Title>{title}</BootstrapModal.Title>
      </BootstrapModal.Header>

      <BootstrapModal.Body>
        {body}
      </BootstrapModal.Body>
      <Spinner spinning={loading} />
      <BootstrapModal.Footer>
        <Button
          variant="primary"
          onClick={primaryOnClick}
          disabled={primaryDisabled}
        >{primaryText}</Button>
      </BootstrapModal.Footer>
    </BootstrapModal>
  );
}
